<template>
  <footer>
    <div class="site-container">
      <div class="flex-wrapper">
        <div class="left">
          <div class="footer-links">
            <router-link :to="{ name: 'home' }">HOME</router-link>
            <a href="https://jovanaivic.pic-time.com/portfolio">PORTFOLIO</a>
            <router-link :to="{ name: 'investment' }">PRICING</router-link>
            <router-link :to="{ name: 'contact' }">CONTACT</router-link>
          </div>
        </div>

        <div class="right">
          <div class="social-links">
            <a href="https://instagram.com/jovanaivic_photography" class="instagram" target="_blank"></a>
            <a href="https://www.linkedin.com/in/jovana-ivic" class="linkedin" target="_blank"></a>
          </div>
        </div>
      </div>

      <div class="copyright">
        All content &copy; 2018-<span v-text="new Date().getFullYear()"></span> Jovana Ivic
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'PageFooter'
}
</script>